import { createLogger, DEBUG, stdSerializers } from 'browser-bunyan';
import { ConsoleFormattedStream } from "./ConsoleFormattedStream.js";
export var logger = createLogger({
  name: 'formative',
  serializers: stdSerializers,
  streams: [{
    level: DEBUG,
    stream: new ConsoleFormattedStream()
  }]
});
if (typeof window !== 'undefined') {
  window.log = logger;
}
var _makeLogger = function makeLogger(impl) {
  return {
    child: function child(opts, simple) {
      return _makeLogger(impl.child(opts, simple));
    },
    debug: impl.debug.bind(impl),
    error: impl.error.bind(impl),
    fatal: impl.fatal.bind(impl),
    info: impl.info.bind(impl),
    level: impl.level.bind(impl),
    trace: impl.trace.bind(impl),
    warn: impl.warn.bind(impl)
  };
};
export default _makeLogger(logger);